import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "brand-apartment-house",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        phone: this.$route.query.phone,
        userTypeStatus: this.$route.query.userTypeStatus == "all" ? "" : 3,
        userTypeAccountStatus: ""
      },
      // 搜索表单

      filterList: [],
      districtList: [],
      adminList: [],
      tableLoading: false,
      tableData: [{}],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getHouseFilterType();
            _this.getAdminList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getAdminList: function getAdminList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getAdminUser({
                type: "all"
              });
            case 1:
              res = _context2.v;
              _this2.adminList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/house/update",
        query: {
          id: row.id,
          userId: row.userInfo.id,
          from: this.$operationLog.editFrom({
            user_type: row.userInfo.user_type,
            status: row.status
          })
        }
      });
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var price, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pn = 1;
                _this3.total = 0;
              }
              if (_this3.searchForm.priceId && _this3.searchForm.priceId.length > 0) {
                price = _this3.searchForm.priceId.split(",");
                _this3.searchForm.minPrice = price[0];
                _this3.searchForm.maxPrice = price[1];
              }
              // this.searchForm.type = 2; // 待审核
              _this3.searchForm.brandVip = 1;
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getQuarterHouseList(_this3.searchForm);
            case 1:
              res = _context3.v;
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.getUserScoreList(_this3.tableData);
              _this3.tableLoading = false;
              _this3.tableData.forEach(function (item) {
                item.userId = item.userInfo.id;
              });
              _this3.getUserListByIds(_this3.tableData, "userId", '', "NewUser");
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getUserScoreList: function getUserScoreList(data) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var userIds, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              userIds = [];
              data.forEach(function (item) {
                var _item$userInfo;
                if (((_item$userInfo = item.userInfo) === null || _item$userInfo === void 0 ? void 0 : _item$userInfo.user_type) === 3) userIds.push(item.userInfo.id);
              });
              userIds = _toConsumableArray(new Set(userIds));
              if (userIds.length) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return _this4.$api.queryQuarterScoreById({
                userIds: userIds
              });
            case 2:
              res = _context4.v;
              if (res && res.data.length) {
                _this4.tableData.forEach(function (item) {
                  var userScore = res.data.find(function (score) {
                    return score.userId === item.userInfo.id;
                  });
                  _this4.$set(item.userInfo, 'userScore', userScore || {});
                });
              }
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.getHouseFilterType();
            case 1:
              res = _context5.v;
              _this5.filterList = res.data;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getDistrictList: function getDistrictList(val) {
      var _this6 = this;
      if (val) {
        this.filterList.cityList.forEach(function (value) {
          if (value.id === val) {
            _this6.searchForm.districtId = "";
            _this6.districtList = value.item;
          }
        });
      } else {
        this.districtList = [];
      }
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row;
      if (row.isSensitive) {
        return "warning-row";
      }
      if (row.blackIp) {
        return "black-ip-row";
      }
      if (row.censor_status == "block") {
        return "warning-row";
      }
      return "";
    }
  }
};